import { useMutation } from "react-query";

import { UserDto } from "@bcasmart/doxecure-commons/doxecureClientTypes";

import { createNewUser } from "@services/users.service";

const useCreateUser = () => useMutation((values: UserDto) => createNewUser(values));

export default useCreateUser;
